import axios from 'axios';
import { TEST_SESSION_HEADER, getTestToken, showTestSessionExpired } from './testSession.js';

// PWA tablet API — no Authorization header (mTLS gestita a livello OS/Nginx).
// L'unica eccezione è la sessione di test aperta da un admin da browser desktop:
// in quel caso il token prende il posto del certificato (vedi testSession.ts).
export const pwaApi = axios.create({
  baseURL: '/api/v1',
  timeout: 30000,
  headers: { 'Content-Type': 'application/json' },
});

pwaApi.interceptors.request.use(config => {
  const token = getTestToken();
  if (token) config.headers.set(TEST_SESSION_HEADER, token);
  return config;
});

pwaApi.interceptors.response.use(
  res => res,
  error => {
    if (!error.response) {
      return Promise.reject(Object.assign(new Error('Connessione assente'), { code: 'OFFLINE' }));
    }
    const code = error.response?.data?.error?.code;
    if (code === 'TEST_SESSION_EXPIRED' || code === 'TEST_SESSION_NOT_ALLOWED') {
      showTestSessionExpired();
    }
    return Promise.reject(error);
  }
);
